module.exports = __webpack_public_path__ + "static/media/loading_animation.564a8af8.svg";